module.exports = __webpack_public_path__ + "files/bade84f1c2205c0a528d87bd10c31541.png";